<template>
  <div class="formdata owner">
    <div class="header-container">
    <h3 id="already_built_question">Handelt es sich bei dem Haus um ein bereits gebautes Gebäude?</h3>
    </div>
    <CustomRadioGroup
        :options="alreadyBuiltAnswers"
        v-model="selectedAnswer"
        aria-labelledby="already_built_question"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'already_built_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>

    <button
        class="button button_yellow right"
        v-if="selectedAnswer"
        @click="submit"
    >
      Weiter
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '@/stores/workflow';
import { alreadyBuiltAnswers, alreadyBuiltApi } from '@/data/alreadyBuiltData.js';
import CustomRadioGroup from '@/components/CustomRadioGroup.vue';

const workflowStore = useWorkflowStore();

const getAnswerEventData = (selectedValue) => {
  const fullAnswer = alreadyBuiltAnswers.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: alreadyBuiltApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available,
    };
  }
  return null;
};

const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.already_built || null;
  },
  set(newValue) {
    const eventData = getAnswerEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_ALREADY_BUILT_ANSWER',
      data: eventData,
    });
  },
});

const submit = () => {
  if (selectedAnswer.value) {
    const eventData = getAnswerEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

